import { Spinner, useToast } from "@chakra-ui/react";
import React, { useContext, useState } from "react"
import { SimpleGrid, Box, Text, Flex,Button } from "@chakra-ui/react";
import { AppContext } from "../../context/AppContext";
import { SubmitBuyer_DB } from "../../api";
import { useNavigate } from "react-router-dom";

export const OrderReview = () => {
  const[userDetails,setuserDetails]=React.useState(JSON.parse(localStorage.getItem("userDetails")));
  const {totalMRP,discount,promoCodeDiscount,getData,cartData,loading}= useContext(AppContext);
  const[placed, setPlaced] = useState(false);
  const[order_id, setOrderid] = useState();
  const [placingOrder, setplacingOrder] = useState(false);
  const [left, setleft] = useState(5);
  const navigate = useNavigate();
  const toast = useToast()

  React.useEffect(()=>{
        getData();
  },[])

  const handleNavigate = () => {
    setplacingOrder(true);
    cartData.map((i) => {
      i.actual_price = parseFloat(i.actual_price*(1-(i.discount/100))).toFixed(2);
      delete i.img1;
      delete i.category;
      delete i.crossed_price;
      delete i.category;
      delete i.country;
      delete i.sub_category;
      delete i.discount;
      delete i.moq;
    })

    fetch(SubmitBuyer_DB,{
      method : "post",
      headers : {"Content-Type": 'application/json'},
      body : JSON.stringify({account:userDetails.userid, products: cartData})
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return Promise.reject(response);
    }).then((res) => {
      setPlaced(true);
      setplacingOrder(false);
      setOrderid(res);
      localStorage.removeItem("cart");
    })
    .catch((response) => toast({
        title: 'Error placing order',
        status: 'error',
        isClosable: true,
    }))
    .finally(() => {
      setTimeout(() => {
        navigate("/");
      }, 5000);
    })

  }
  return (
    <Box mt="20px">
      {loading && <Box zIndex={'2'} opacity='0.8' display={'grid'} position='fixed' bottom='0px' placeContent='center' w='100vw' h='110vh' bg='black'><Spinner color='#fff' size='xl' /></Box>}
    <Box w={{ base: '100%', md: '100%', lg: '70%' }} m="auto" mt='10px'>
      <Box justifyContent='space-between' wrap='wrap'  display={{base:"block", lg:"flex"} } >
        <SimpleGrid columns={1} w={{   md: '100%'}} mr="20px"  padding={{base:"20px", lg:"0px"}}>
          <Box>
            <Text color='rgb(21,27,57)'fontSize='24px'>PRODUCTS</Text>
            <Box padding='10px' mb='50px' id='boxshadow'>
              {cartData.map((post)=>(
                <Box  mb="10px" key={post.title}>
                <Flex >
                  <Box  mr='40px'>
                    <Text fontSize='16px' mb='20px' w="80%">{post.title}</Text>
                      <Text fontSize='12px' lineHeight='30px'>
                        {post.manufacturer}
                      </Text>
                  </Box>
                  <Box ml="auto" w="90px" >
                    <Box ml="0px" >
                        <Text fontSize='14px' color='#ef4281' >Rs.{post.actual_price}</Text>
                        {post.crossed_price && <Text mb='15px' color='#151B3999' fontWeight={'400'} textDecoration={'line-through'} fontSize={'12px'}>Rs.{post.crossed_price.toFixed(2)}</Text>}
                      <Text fontSize={'12px'} color='#151B3999'>QTY: {post.quantity ? post.quantity : 1}</Text>
                    </Box>
                  </Box>
                </Flex>
                <hr/>
              </Box>))}
            </Box>
            <Box padding='10px'mb='60px' id='boxshadow' >
              <Text color='rgba(21,27,57,.6)' fontSize='12px'  mb='20px'>Customer Notes</Text>
              <textarea style={{padding: '5px'}} name="paragraph_text" cols="30" rows="5" ></textarea>
            </Box>
          </Box>
        </SimpleGrid>      
        <Box height='auto' padding='10px' id='boxshadow2' w={{base:"100%",lg:"50%"} } mt="20px">
            <Text color='rgba(21,27,57,.6)'fontSize='12px'>PAYMENT DETAILS</Text>
            <Box   lineHeight='40px'  >
            <Flex justifyContent="space-between">
              <Text>MRP Total</Text>
              <Text>Rs.{totalMRP.toFixed(2)}</Text>
            </Flex>
            <Flex justifyContent="space-between">
              <Text>Discount</Text>
              <Text>- Rs.{discount.toFixed(2)}</Text>
            </Flex>
            {
              promoCodeDiscount==0? <Box></Box> : 
              <Flex fontSize={'14px'} mb='10px' justifyContent={'space-between'}>
                  <Text>Promocode Discount</Text>
                  <Text>-Rs.{parseFloat(promoCodeDiscount).toFixed(2)}</Text>
              </Flex>
            }

            <Flex justifyContent="space-between" fontWeight='bold'>
              <Text >Total Amount</Text>
              <Text > *Rs.{(totalMRP-discount).toFixed(2)}</Text>
            </Flex>
            </Box>
            <Box bg='#f3f8ec' mt='20px' p='10px'>
              <Text color='#378f30' fontSize='14px'> TOTAL SAVINGS   RS.{(discount+promoCodeDiscount).toFixed(2)}</Text>
            </Box>

            <Flex justifyContent='space-between' mt='30px'>
              <Box >
                <Text>TOTAL AMOUNT</Text>
                <Text fontWeight='bold' fontSize='20px'> Rs.{(totalMRP-discount).toFixed(2)}</Text>
              </Box>
              <Box >
                {placed
                ?<Button
                  bg='#5e17eb'
                  color='#fff'
                  variant="solid"
                  size='lg'
                  colorScheme='orange'
                  isLoading={placingOrder}
                >
                  Placed
                </Button>
                :<Button
                  bg='#5e17eb'
                  color='#fff'
                  variant="solid"
                  size='lg'
                  colorScheme='orange'
                  onClick={handleNavigate}
                  isLoading={placingOrder}
                >
                  Place Order
                </Button>}
              </Box>
            </Flex>
              {placed ? <Text> Order Placed id:  {order_id} </Text> :<></>}
          </Box>
      </Box>
    </Box>
    </Box>
  );
};


